import { useT } from "../lang/LangContext";

export function Contact() {
  const t = useT();

  return (
    <section
      id="contact"
      style={{ borderTop: "3px solid var(--fg)", background: "var(--card)" }}
    >
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "64px 20px" }}>
        <h2
          style={{
            margin: "0 0 10px",
            fontFamily: "'Archivo Black',sans-serif",
            fontSize: "clamp(38px,9vw,110px)",
            lineHeight: 0.86,
            letterSpacing: "-0.045em",
            textTransform: "uppercase",
          }}
        >
          {t(
            <>
              Let's build
              <br />
              something loud
            </>,
            <>
              Vamos construir
              <br />
              algo barulhento
            </>
          )}
        </h2>
        <p style={{ margin: "0 0 28px", fontSize: 16, maxWidth: 520, lineHeight: 1.6 }}>
          {t(
            "Hiring, collaborating, or just want to argue about architecture, my inbox is open.",
            "Contratando, colaborando ou só querendo discutir arquitetura, minha caixa de entrada está aberta."
          )}
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
          <a
            href="mailto:rodrigo@0xrodrigo.dev"
            className="btn btn-press"
            style={{
              fontSize: 14,
              letterSpacing: "0.05em",
              background: "var(--accent)",
              color: "var(--bg)",
              padding: "15px 20px",
              boxShadow: "7px 7px 0 var(--fg)",
            }}
          >
            EMAIL ME ↗
          </a>
          <a
            href="https://www.linkedin.com/in/rodrigo-ferreira-032192170/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-invert"
            style={{
              fontSize: 14,
              letterSpacing: "0.05em",
              color: "var(--fg)",
              padding: "15px 20px",
              boxShadow: "7px 7px 0 var(--accent)",
            }}
          >
            LINKEDIN ↗
          </a>
          <a
            href="https://github.com/r-drg"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-invert"
            style={{
              fontSize: 14,
              letterSpacing: "0.05em",
              color: "var(--fg)",
              padding: "15px 20px",
              boxShadow: "7px 7px 0 var(--accent)",
            }}
          >
            GITHUB ↗
          </a>
          <a
            href="/Rodrigo_Ferreira_Resume.pdf"
            download
            className="btn btn-dashed-invert"
            style={{
              fontSize: 14,
              letterSpacing: "0.05em",
              color: "var(--fg)",
              border: "3px dashed var(--fg)",
              padding: "15px 20px",
              background: "transparent",
            }}
          >
            {t("DOWNLOAD RESUME", "BAIXAR CURRÍCULO")}
          </a>
        </div>
      </div>
    </section>
  );
}
